import useWebsiteBuilder, { WebsiteBuilderContent, WebsiteBuilderStyle } from 'Hooks/useWebsiteBuilder';
import { httpsLink, makeKey, styx } from 'modules/Utils';
import { CSSProperties } from 'react';
import { SOCIAL_PLATFORMS_INFO } from 'modules/Const';
import Icon from 'elements/Icon';
import { whiteOrBlackTextColor } from 'helpers/StyleUtils';

interface SocialPlatformsPreviewContentProps {
    contentIndex: number;
    websiteContent: WebsiteBuilderContent[];
    websiteStyle: WebsiteBuilderStyle;
    style?: CSSProperties;
    onClickContentBlock?: (index: number) => void;
}

const SocialPlatformsPreviewContent = ({
    contentIndex,
    websiteContent: websiteContentProp,
    websiteStyle: websiteStyleProp,
    style: styleProp,
    onClickContentBlock,
}: SocialPlatformsPreviewContentProps) => {
    const {
        websiteContent: websiteContentState,
        websiteStyle: websiteStyleState,
    } = useWebsiteBuilder();

    const websiteContent = websiteContentProp || websiteContentState;
    const websiteStyle = websiteStyleProp || websiteStyleState;

    const {
        textColor: OLD,
        backgroundColor: backgroundColorWebsiteStyle,
    } = websiteStyle;

    const isContentBackgroundColorEnabled = websiteContent[contentIndex].isContentBackgroundColorEnabled;
    const contentBackgroundColor = websiteContent[contentIndex].contentBackgroundColor;
    const backgroundColor = isContentBackgroundColorEnabled ? contentBackgroundColor || backgroundColorWebsiteStyle : backgroundColorWebsiteStyle;

    const isContentTextColorEnabled = websiteContent[contentIndex].isContentTextColorEnabled;
    const contentTextColor = websiteContent[contentIndex].contentTextColor

    const textColor = isContentTextColorEnabled ? contentTextColor : whiteOrBlackTextColor(backgroundColor);

    const socialPlatformsContent = websiteContent[contentIndex].socialPlatformsContent;

    return (
        <div
            className="socialPlatformsPreviewContentComponent"
            style={styx(
                sty.socialPlatformsPreviewContentComponent,
                styleProp,
            )}
            onClick={() => onClickContentBlock?.(contentIndex)}
        >
            {socialPlatformsContent?.platforms.map((platform, index) => {
                const platformInfo = SOCIAL_PLATFORMS_INFO[platform.name];

                const platformLink = httpsLink(platform.link);
                if (!platform.isEnabled || !platformLink) {
                    return null;
                }
                return (
                    <div
                        key={makeKey(platform.name, index, contentIndex)}
                        className="socialPlatformsPreviewContentPlatform"
                        style={styx(sty.socialPlatformsPreviewContentPlatform)}
                    >
                        <Icon
                            className="socialPlatformsPreviewContentIcon"
                            icon={platformInfo?.iconFlat}
                            size={24}
                            color={textColor}
                            onClick={() => {
                                window.open(platformLink, '_blank');
                            }}
                        />
                    </div>
                )
            })}
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    socialPlatformsPreviewContentComponent: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        gap: 8,
    },
    socialPlatformsPreviewContentPlatform: {
        display: 'flex',
        alignItems: 'center',
    }
}

export default SocialPlatformsPreviewContent;